// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPIConfig, getBrandInCaps } from '@tcp/core/src/utils/utils';
import { INITIALIZE_PAYPAL_BUTTON } from '@tcp/core/src/constants/brandSpecific.constants';
import BagPageSelector from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import checkoutSelectors from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import { ServiceResponseError } from '@tcp/core/src/utils/errorMessage.util';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import PayPalButton from '../organism/PaypalButton';
import bagPageActions from '../../../../BagPage/container/BagPage.actions';
import CONSTANTS from '../../../../Checkout/Checkout.constants';
import { getSetIsPaypalPaymentSettings } from '../../../../Checkout/container/Checkout.action';

export class PayPalButtonContainer extends React.PureComponent {
  initalizePayPalButton = (data) => {
    const {
      startPaypalCheckout,
      paypalAuthorizationHandle,
      clearPaypalSettingsWeb,
      isBillingPage,
      setAfterPayProgress,
      isShowPayWithPaypal,
    } = this.props;
    const { containerId, height, paypalEnv } = data;
    let label = isBillingPage ? CONSTANTS.CHECKOUT : CONSTANTS.PAYPAL_LABEL;
    if (isShowPayWithPaypal) {
      label = CONSTANTS.PAY_WITH;
    }
    const options = {
      locale: CONSTANTS.PAYPAL_LOCATE,
      style: {
        size: 'responsive',
        color: isBillingPage ? CONSTANTS.PAYPAL_CTA_COLOR.GOLD : CONSTANTS.PAYPAL_CTA_COLOR.DEFAULT,
        shape: INITIALIZE_PAYPAL_BUTTON[getBrandInCaps()],
        label,
        tagline: false,
        height,
      },
      funding: {
        disallowed: [window.paypal && window.paypal.FUNDING.CREDIT],
      },
      env: paypalEnv,
      payment: () => {
        setAfterPayProgress(false);
        pushEventToAdobeAnalytics('payment_billing_initiate', 'paypal');
        return new Promise((resolve, reject) =>
          startPaypalCheckout({ resolve, reject, isBillingPage })
        );
      },
      onAuthorize: paypalAuthorizationHandle,
      onCancel: clearPaypalSettingsWeb,
      onError: (error) => {
        throw new ServiceResponseError(error);
      },
    };
    window.paypal.Button.render(options, `#${containerId}`);
  };

  render() {
    const {
      isQualifedOrder,
      containerId,
      height,
      navigation,
      getPayPalSettings,
      payPalWebViewHandle,
      paypalAuthorizationHandle,
      clearPaypalSettings,
      setVenmoState,
      isBillingPage,
      closeModal,
      top,
      fullWidth,
      fullHeight,
      isRenderDone,
      isPaypalLibraryAction,
      isPaypalLibraryRendered,
      showCondensedHeader,
      fromPage,
    } = this.props;
    const apiConfigObj = getAPIConfig();
    const { paypalEnv, paypalStaticUrl } = apiConfigObj;
    return (
      <PayPalButton
        isQualifedOrder={isQualifedOrder}
        height={height}
        initalizePayPalButton={this.initalizePayPalButton}
        containerId={containerId}
        navigation={navigation}
        getPayPalSettings={getPayPalSettings}
        payPalWebViewHandle={payPalWebViewHandle}
        paypalAuthorizationHandle={paypalAuthorizationHandle}
        clearPaypalSettings={clearPaypalSettings}
        paypalEnv={paypalEnv}
        paypalStaticUrl={paypalStaticUrl}
        setVenmoState={setVenmoState}
        closeModal={closeModal}
        top={top}
        isBillingPage={isBillingPage}
        fullWidth={fullWidth}
        fullHeight={fullHeight}
        isRenderDone={isRenderDone}
        isPaypalLibraryAction={isPaypalLibraryAction}
        isPaypalLibraryRendered={isPaypalLibraryRendered}
        showCondensedHeader={showCondensedHeader}
        fromPage={fromPage}
      />
    );
  }
}

// eslint-disable-next-line no-unused-vars
export const mapStateToProps = (state) => ({
  isQualifedOrder: false,
  bagLoading: BagPageSelector.isBagLoading(state),
  isPaypalLibraryRendered: BagPageSelector.getIsPayPalLibraryRendered(state),
  isGettingPaypalSettings: BagPageSelector.getIsGettingPaypalSettings(state),
  getPayPalSettings: checkoutSelectors.getPayPalSettings(state),
});

export const mapDispatchToProps = (dispatch) => {
  return {
    startPaypalCheckout: (payload) => {
      dispatch(bagPageActions.startPaypalCheckout(payload));
    },
    paypalAuthorizationHandle: (payload) => {
      dispatch(bagPageActions.paypalAuthorization(payload));
    },
    clearPaypalSettingsWeb: () => {
      dispatch(getSetIsPaypalPaymentSettings(null));
    },
    clearPaypalSettings: (isBillingPage) => {
      dispatch(bagPageActions.startPaypalNativeCheckout({ isBillingPage }));
    },
    payPalWebViewHandle: (payload) => {
      dispatch(bagPageActions.getSetPayPalWebView(payload));
    },
    isRenderDone: (payload) => {
      dispatch(bagPageActions.isPaypalRenderDone(payload));
    },
    isPaypalLibraryAction: (payload) => {
      dispatch(bagPageActions.isPaypalLibraryAction(payload));
    },
    startPaypalNativeCheckoutAction: (isBillingPage) => {
      dispatch(bagPageActions.startPaypalNativeCheckout({ isBillingPage }));
    },
  };
};

PayPalButtonContainer.propTypes = {
  isBillingPage: PropTypes.bool.isRequired,
  getPayPalSettings: PropTypes.func.isRequired,
  payPalWebViewHandle: PropTypes.func.isRequired,
  startPaypalCheckout: PropTypes.func.isRequired,
  paypalAuthorizationHandle: PropTypes.func.isRequired,
  clearPaypalSettingsWeb: PropTypes.func.isRequired,
  isQualifedOrder: PropTypes.bool.isRequired,
  containerId: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  navigation: PropTypes.shape({}).isRequired,
  clearPaypalSettings: PropTypes.func.isRequired,
  setVenmoState: PropTypes.func.isRequired,
  closeModal: PropTypes.bool.isRequired,
  top: PropTypes.string.isRequired,
  fullWidth: PropTypes.string.isRequired,
  fullHeight: PropTypes.bool.isRequired,
  isRenderDone: PropTypes.bool.isRequired,
  isPaypalLibraryAction: PropTypes.bool.isRequired,
  isPaypalLibraryRendered: PropTypes.bool.isRequired,
  showCondensedHeader: PropTypes.func.isRequired,
  startPaypalNativeCheckoutAction: PropTypes.func.isRequired,
  isGettingPaypalSettings: PropTypes.bool.isRequired,
  setAfterPayProgress: PropTypes.func,
  isShowPayWithPaypal: PropTypes.bool,
};

PayPalButtonContainer.defaultProps = {
  setAfterPayProgress: () => {},
  isShowPayWithPaypal: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(PayPalButtonContainer);
